<template>
  <div class="d-flex">
    <SlotNumber v-for="(n, key) in numbers" v-bind:key="key" :select="n" :timeout="wait-(key*1000)" :start="key" />
  </div>
</template>
<script>
import SlotNumber from './SlotNumber.vue'

export default {
  name: 'DisplaySpinNumber',
  components: {
    SlotNumber
  },
  props: {
    length: {
      type: [Number, String],
      required: true
    },
    wait: {
      type: [Number, Boolean],
      default: 30000
    },
    result: {
      type: String,
      default: null
    }
  },
  computed: {
    numbers() {
      if (this.result)
        return this.result.split('')

      return new Array(+this.length)
    }
  }
}
</script>
